import { ArbeitsbereichConfig } from '../../../app/config/model/arbeitsbereich-config.model';
import { Workspace } from '../../../app/shared/enum/workspace.enum';
import { LayerCode } from '../../../app/shared/enum/layer-code.enum';

export const ARBEITSBEREICH_CONFIG: ArbeitsbereichConfig = {
  arbeitsbereiche: [
    {
      id: Workspace.sbb_eigentumsflaeche,
      urlParam: Workspace.sbb_eigentumsflaeche,
      isActive: true,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.SBB-EIGENTUMSFLAECHE',
      haveSettings: false,
      hideListView: false,
      popupTitle: 'POPUP.ARBEITSBEREICH.IMMOBILIEN.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_teilparzelle,
        },
        {
          fkLayer: LayerCode.f_parzellen,
        },
        {
          fkLayer: LayerCode.f_parzelleDritt,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.parzellen,
          ignoreLayerIds: [],
        },
      ],
    },
    {
      id: Workspace.verkaufsobjekte,
      urlParam: Workspace.verkaufsobjekte,
      prefix: 'vo',
      isActive: false,
      haveSettings: false,
      hideListView: false,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.VERKAUFSOBJEKTE',
      popupTitle: 'POPUP.ARBEITSBEREICH.VERKAUF.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_verkaufsobjekte,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.verkaufsobjekte,
          fkLayerEdit: LayerCode.p_verkaufsobjekte,
          fkTooltipLayer: LayerCode.f_public_verkaufsobjekte,
          ignoreLayerIds: [],
        },
      ],
    },
    {
      id: Workspace.strategieflaechen,
      urlParam: Workspace.strategieflaechen,
      isActive: false,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.STRATEGIEFLAECHEN',
      haveSettings: false,
      hideListView: false,
      popupTitle: 'POPUP.ARBEITSBEREICH.STRATEGIEFLAECHEN.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_public_strategieflaeche,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.strategieflaeche,
        },
      ],
    },
    {
      id: Workspace.sap,
      urlParam: Workspace.sap,
      isActive: false,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.SAP-OBJEKTE',
      haveSettings: false,
      hideListView: true,
      popupTitle: 'POPUP.ARBEITSBEREICH.SAP.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_public_refx_gb,
        },
        {
          fkLayer: LayerCode.f_public_refx_gr,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.sap,
          ignoreLayerIds: [],
        },
        {
          fkLayer: LayerCode.parzellen_view,
        },
      ],
    },
    {
      id: Workspace.areale,
      urlParam: Workspace.areale,
      isActive: false,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.AREALE',
      haveSettings: false,
      hideListView: false,
      popupTitle: 'POPUP.ARBEITSBEREICH.AREALE.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_public_areale,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.areale_view,
        },
        {
          fkLayer: LayerCode.parzellen,
          ignoreLayerIds: [],
        },
      ],
    },
    {
      id: Workspace.nutzflaecheInfra,
      urlParam: Workspace.nutzflaecheInfra,
      isActive: false,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.NUTZFLAECHE_INFRA',
      haveSettings: false,
      hideListView: true,
      popupTitle: 'POPUP.ARBEITSBEREICH.NUTZFLAECHEINFRA.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_public_nutzflaeche,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.nutzflaeche_infra,
        },
      ],
    },
    {
      id: Workspace.denkmalpflege,
      urlParam: Workspace.denkmalpflege,
      hideListView: true,
      isActive: true,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.DENKMALPFLEGE',
      popupTitle: 'POPUP.ARBEITSBEREICH.ISBA.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_isba_eo_report,
        },
        {
          fkLayer: LayerCode.f_isba_ko_report,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.denkmalpflege,
          ignoreLayerIds: [0, 4],
        },
        {
          fkLayer: LayerCode.isos,
          ignoreLayerIds: [],
        },
      ],
    },
    {
      id: Workspace.gebaeude,
      urlParam: Workspace.gebaeude,
      hideListView: true,
      isActive: true,
      name: 'HEADER_PANEL.ARBEITSBEREICH.NAME.GEBAEUDE',
      popupTitle: 'POPUP.ARBEITSBEREICH.GEBAEUDE.TITLE',
      editableLayers: [
        {
          fkLayer: LayerCode.f_gebaeude,
        },
      ],
      layers: [
        {
          fkLayer: LayerCode.gebaeude,
          ignoreLayerIds: [],
        },
      ],
    },
  ],
};
